import I18nJS from "i18n-js";

import en from "./locales/en";
import es from "./locales/es";
import es_EC from "./locales/es-EC";
import es_MX from "./locales/es-MX";
import es_CL from "./locales/es-CL";
import { ReactText, useEffect, useState } from "react";
import { createContainer } from "unstated-next";


const useI18n = () => {
	const [locales, setLocales] = useState<readonly string[]>([]);
	const [currentLocale, setCurrentLocale] = useState<string>();
	const [currentLanguageCode, setCurrentLanguageCode] = useState<string>();
	const [translationsReady, setTranslationsReady] = useState<boolean>(false);

	const setLocale = (languageTag: string) => {
		const localeToSet = locales.find(l => l === languageTag);
		if (localeToSet){
			I18nJS.locale = localeToSet;
			setCurrentLocale(localeToSet);
			return;
		}
		throw Error(`Locale not found - ${languageTag}`);
	}

	const formatToCurrency = (amount: number, precision: number = 2): string => {
		return I18nJS.toCurrency(amount, { precision: precision, delimiter: I18nJS.t("formats.numberDelimiter"), separator: I18nJS.t("formats.decimalSeparator"), unit: I18nJS.t("formats.currencySymbol") });
	}

	/* const formatNumber = (amount: number, precision: number = 0): string => {
		return I18nJS.toNumber(amount, { precision: precision, delimiter: I18nJS.t("formats.numberDelimiter"), separator: I18nJS.t("formats.decimalSeparator") });
	} */

	const formatNumber = (value: ReactText): string => {
		return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, I18nJS.t("formats.numberDelimiter"));
	}

	const parseNumber = (value: string):string => {
		const delimiter = I18nJS.t("formats.numberDelimiter")
		const regex = new RegExp(`\$\s?|([${delimiter}])`, "g");
		let cleanedValue = value.replace(regex, '');
		return cleanedValue;
	}

	const formatPercentage = (amount: number, precision: number = 0): string => {
		return I18nJS.toPercentage(amount, { precision: precision, delimiter: I18nJS.t("formats.numberDelimiter"), separator: I18nJS.t("formats.decimalSeparator") });
	}

	/*
		%a     - The abbreviated weekday name (Sun)
		%A     - The full weekday name (Sunday)
		%b     - The abbreviated month name (Jan)
		%B     - The full month name (January)
		%c     - The preferred local date and time representation
		%d     - Day of the month (01..31)
		%-d    - Day of the month (1..31)
		%H     - Hour of the day, 24-hour clock (00..23)
		%-H/%k - Hour of the day, 24-hour clock (0..23)
		%I     - Hour of the day, 12-hour clock (01..12)
		%-I/%l - Hour of the day, 12-hour clock (1..12)
		%m     - Month of the year (01..12)
		%-m    - Month of the year (1..12)
		%M     - Minute of the hour (00..59)
		%-M    - Minute of the hour (0..59)
		%p     - Meridian indicator (AM  or  PM)
		%P     - Meridian indicator (am  or  pm)
		%S     - Second of the minute (00..60)
		%-S    - Second of the minute (0..60)
		%w     - Day of the week (Sunday is 0, 0..6)
		%y     - Year without a century (00..99)
		%-y    - Year without a century (0..99)
		%Y     - Year with century
		%z/%Z  - Timezone offset (+0545)
		For example:
		%d/%m/%Y-%H:%M:%S of 2020-08-21T22:08:43.308Z will return 21/08/2020-16:08:43
	*/
	const formatDate = (date: Date, format: string): string => {
		return I18nJS.strftime(date, format);
	}

	const translate = (key:string): string => {
		return I18nJS.t(key);
	}

	useEffect(() => {
		I18nJS.fallbacks = true;
		I18nJS.translations = {
		  'en':en,
		  'es':es,
		  'es-EC':es_EC,
		  'es-MX':es_MX,
		  'es-CL':es_CL,
		};
		const locales = navigator.languages;
		if (locales && locales.length){
			I18nJS.locale = locales[0];
			setLocales(locales);
			setCurrentLocale(locales[0]);
		}
		setTranslationsReady(true);
		setTimeout(function() {
			document.getElementById("___loader").style.display = "none"
		}, 1500)
	},[])

	return {
		currentLocale,
		currentLanguageCode,
		locales,
		formatToCurrency,
		formatNumber,
		parseNumber,
		formatPercentage,
		formatDate,
		setLocale,
		translate,
		translationsReady
	};
};


export const TranslationContainer = createContainer(useI18n);